import { render, staticRenderFns } from "./ConsentToContact.vue?vue&type=template&id=2906c6be&scoped=true"
import script from "./ConsentToContact.vue?vue&type=script&lang=js"
export * from "./ConsentToContact.vue?vue&type=script&lang=js"
import style0 from "./ConsentToContact.vue?vue&type=style&index=0&id=2906c6be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2906c6be",
  null
  
)

export default component.exports